
import Vue from 'vue'

export default Vue.extend({
   name: 'Action',
   props: {
      value: Boolean,
      params: Object as () => { text: string },
   },
   computed: {
      label(): string {
         return this.params && this.params.text ? this.params.text : ''
      },
   },
})
